<template>
  <v-container fluid class="px-4 pa-md-8">
    <v-app-bar fixed class="d-sm-none" elevate-on-scroll tile flat clipped-right>
      <v-row class="ml-n7 mr-n7">
        <v-col cols="12" class="">
          <input-localizacion modo="recoger" @update="addressExists" />
        </v-col>
      </v-row>
    </v-app-bar>
    <v-list flat dense class>
      <v-list-item-group class>
        <v-list-item class="px-0" @click="back()">
          <v-list-item-icon :disabled="loadingRest" class>
            <v-icon class="headline" color="black">mdi-arrow-left</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="py-0 my-0">
            <v-list-item-title
              class="headline font-weight-bold py-2"
            >{{$t('pedido.totem.carrito.modo.btn.recoger')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <v-row class="d-none d-sm-flex">
      <v-col cols="12">
        <input-localizacion modo="recoger" @update="addressExists" />
      </v-col>
    </v-row>
    <v-row v-if="loadingRest">
      <v-col class="pb-0" cols="12" sm="6" md="4" v-for="n in 6" :key="n">
        <v-sheet tile>
          <v-skeleton-loader class="mx-auto pa-3" max-width="100%" type="image"></v-skeleton-loader>

          <v-skeleton-loader class="ml-3" type="heading"></v-skeleton-loader>
          <v-skeleton-loader type="actions"></v-skeleton-loader>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        sm="6"
        md="4"
        v-for="(restaurant, index) in restaurantesFiltrados"
        :key="index"
      >
        <restaurant-card v-bind:obj="restaurant" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import restaurantCard from "@/views/Propio/RestaurantCardPropio.vue";
import inputLocalizacion from "@/views/Propio/InputLocalizacionPropio.vue";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    restaurantCard,
    inputLocalizacion
  },
  data() {
    return {
      loadingAddress: false,
      showRestaurants: false
    };
  },
  mounted() {
    this.setModo();
  },
  metaInfo() {
    return {
      title: this.titulo,
      //titleTemplate: this.webPropio.general.seo.titleTemplate,
      meta: [
        {
          name: "description",
          content: this.descripcion
        }
        /*{
          property: "og:title",
          content: "Cervecería el Pikoteo"
        },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" }*/
      ]
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.app.isMobile;
    },
    titulo() {
      return this.webPropio.domicilio &&
        this.webPropio.recoger.seo &&
        this.webPropio.recoger.seo.title
        ? this.webPropio.recoger.seo.title
        : "RECOGER";
    },
    descripcion() {
      return this.webPropio.domicilio &&
        this.webPropio.recoger.seo &&
        this.webPropio.recoger.seo.description
        ? this.webPropio.recoger.seo.description
        : "Pide a recoger";
    },
    ...mapState({
      webPropio: state => state.propio.negocioPropioObj.web,
      loadingRest: state => state.direcciones.loadingRest
    }),
    ...mapGetters({
      restaurantesFiltrados: "restaurante/filtradoRestauranteNegocios"
    })
  },
  methods: {
    addressExists(data) {
      this.showRestaurants = data;
    },
    back() {
      this.$store.commit("snackbar/reset");
      this.$router.push({
        path: "/"
      });
    }
  },
  watch: {},
  mounted() {
    this.$store.commit("direcciones/setModoEligiendo", "recoger");
  }
};
</script>

<style scoped>
.border {
  border: 1px solid #000;
}
</style>